import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    position: 'relative',
  },

  fixedHeight: {
    height: '50px',
  },

  title: {
    color: '#B2B9C0',
    position: 'absolute',
    top: '14px',
    left: '57px',
    userSelect: 'none',
    fontSize: '14px',
    cursor: 'text',
    pointerEvents: 'none',
  },

  input: {
    height: '100%',
    width: '100%',
    color: '#102131',
    fontSize: '16px',
    padding: '22px 0 22px 57px',
    border: 'none',
    borderRadius: '12px',
    backgroundColor: '#fff',
    transition: 'all 0.15s ease-in-out',

    '&:invalid': {
      border: 'none',
      boxShadow: 'none',
    },

    '&:focus': {
      border: '1px solid #102131',
      boxShadow: 'none',
    },

    '&:focus + span': {
      color: '#AABAC5;',
      transition: 'color 0.15s',
      top: '-24px',
      left: '16px',
      fontSize: '12px',
      cursor: 'auto',
    },

    '&:hover': {
      boxShadow: '0px 16px 32px rgba(16, 33, 49, 0.08)',
    },
  },

  grayBackground: {
    backgroundColor: '#f3f6f9',
    '&:focus': {
      backgroundColor: 'white',
    },
  },

  textArea: {
    height: '150px',
    paddingTop: '14px',
  },

  inputWithValue: {
    '& + span': {
      color: '#AABAC5',
      transition: 'color 0.15s',
      top: '-24px',
      left: '16px',
      fontSize: '12px',
      cursor: 'auto',
    },
  },

  inputError: {
    border: '1px solid #E84118',
    backgroundColor: 'white',
  },

  inputCorrect: {
    border: '1px solid #4CD137',
    backgroundColor: 'white',
  },

  image: {
    position: 'absolute',
    top: '14px',
    left: '19px',
    cursor: 'text',
    pointerEvents: 'none',
  },

  statusIcon: {
    position: 'absolute',
    top: '15px',
    right: '10px',
  },

  disabled: {
    cursor: 'not-allowed',
    backgroundColor: '#F0F8FF',
    '&:hover': {
      boxShadow: 'none',
    },
  },
});
